import React, { Component } from "react";
import validator from "../Validators/Validators";
import PhoneInput from "../PhoneInput/PhoneInput";
import "./SignIn.css";
import Http from "../Http/Http";

class SignIn extends Component {
  constructor() {
    super();

    this.state = {
      countryCode: "0057",
      phoneNumber: "",
      errors: {
        phoneNumber: false,
        phoneNumberNotExists: false
      },
      isSubmitted: false,
      isSubmitting: false,
      paymentRequest: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.requestCode = this.requestCode.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);

    this.setState({
      paymentRequest: params.get("paymentRequest")
    });
  }

  handleChange(event) {
    const target = event.target;

    this.setState(
      {
        [target.name]: target.value
      },
      () => {
        if (this.state.isSubmitted) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const { countryCode, phoneNumber } = this.state;
    const errors = {
      phoneNumber: !validator.isValidPhoneNumber(countryCode, phoneNumber)
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ isSubmitted: true });
    this.validateForm(this.requestCode);
  }

  requestCode() {
    this.setState({ isSubmitting: true });

    const { paymentRequest, countryCode, phoneNumber } = this.state;

    // remove the trailing '00' from the phone number
    const formattedNumber = countryCode.concat(phoneNumber).substring(2);

    Http.get(`/wallet/$${formattedNumber}`)
      .then(response => {
        // get the default signer from the response
        const signerId = response.data.default;

        if (signerId) {
          return signerId;
        } else {
          throw Error("No default signer");
        }
      })
      .then(signerId => {
        const navigateToUrl =
          `/ingresar/confirmar?phone=${formattedNumber}` +
          (paymentRequest ? `&paymentRequest=${paymentRequest}` : "");

        this.props.history.push(navigateToUrl);
      })
      .catch(() => {
        const errors = {
          phoneNumberNotExists: true
        };

        this.setState({ errors, isSubmitting: false });
      });
  }

  render() {
    const { countryCode, phoneNumber, errors } = this.state;

    return (
      <form className="signin" action="" onSubmit={this.handleSubmit}>
        <h1 className="signin-title">Iniciar sesión</h1>
        <p>
          Ingrese su número de teléfono para solicitar un código de inicio de
          sesión
        </p>
        <PhoneInput
          countryCode={countryCode}
          phoneNumber={phoneNumber}
          onChange={this.handleChange}
          errors={errors}
        />
        <button className="signin-submit button-green">
          Solicita un código
        </button>
      </form>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/SignIn/SignIn.js